<template>
  <div>
    <h3 style="text-transform: uppercase; margin-bottom: 12px;">
      Cancel Campaign
    </h3>
    <form @submit.prevent="cancelCampaign()">
      <div>
        <div class="form-group">
          <input
            type="text"
            name="status"
            id="status"
            class="form-control"
            disabled
            v-model="status"
          />
          <label style="letter-spacing: 0px; font-size: 12px;">Status:</label>
        </div>
        <div class="form-group" v-if="updatable">
          <input
            type="text"
            name="note"
            id="note"
            class="form-control"
            v-model="note"
            required
          />
          <label style="letter-spacing: 0px; font-size: 12px;"
            ><span style="color: red;">*&nbsp;</span>Note:</label
          >
        </div>
      </div>
      <button
        v-if="updatable"
        class="btn btn-tertiary"
        style="padding: 0px 10px;border-radius: 0px; height: 35px;"
        :disabled="(status !== 'In Progress' && status !== 'Booked') || !note"
      >
        Cancel
      </button>
    </form>
  </div>
</template>

<script>
import CampaignServiceV2 from '../../services/V2/CampaignServiceV2';

export default {
  data() {
    return {
      note: null,
    };
  },
  props: ['id', 'status'],
  computed: {
    updatable() {
      return this.status === 'Booked' || this.status === 'In Progress'
        ? true
        : false;
    },
  },
  methods: {
    async cancelCampaign() {
      try {
        const confirmed = await this.$swal({
          type: 'warning',
          title: 'Cancel Campaign?',
          text: 'Are you sure you want to cancel this campaign?',
          showCancelButton: true,
          confirmButtonText: 'Yes',
        });

        if (confirmed && confirmed.dismiss) {
          return;
        }

        await CampaignServiceV2.cancelCampaign(this.id, {note: this.note});
        this.note = '';

        this.$emit('on-campaign-cancelled');

        this.$swal({
          type: 'success',
          title: 'Campaign cancelled',
        });
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'Error',
          text: 'Failed to cancel campaign.',
        });
      }
    },
  },
};
</script>
